import React, { useRef, useState } from "react";
import { useHttp } from "../../hooks/useHttp";
import { SITE_URLS } from "../../util/constants";

const ValidateCode = ({ stepHandler, emailSelected, userIdHandler }) => {
  const { sendRequest } = useHttp();

  const tokenRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");

  const ValidateCode = async () => {
    const responseData = await sendRequest(
      SITE_URLS.FORGOT_PASSWORD.CHECK_CODE,
      "POST",
      JSON.stringify({
        verification_token: tokenRef.current.value,
        email: emailSelected,
      }),
      {
        "Content-Type": "application/json",
      }
    );
    if (responseData.success) {
      setErrorMessage("");
      stepHandler("3");
      userIdHandler(responseData.user_id);
    } else {
      setErrorMessage(responseData.message || "Código inválido.");
    }
  };

  const submitHandler = async () => {
    ValidateCode();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1 className="form-text-home text-center" style={{ maxWidth: "690px" }}>
        Um código de recuperação foi enviado para seu email!
      </h1>
      <p className="text-center mb-50">
        Insira abaixo o código para continuar a alteração de senha.
      </p>
      <input
        className="input-item input-item-email px-3 "
        style={{
          width: "100%",
          maxWidth: "469px",
          textAlign: "center",
          fontSize: "20px",
        }}
        placeholder="Código de recuperação de senha*"
        ref={tokenRef}
      />
      <div className="btn-wrapper mt-0">
        <button
          className="btn theme-btn-1 btn-effect-1 text-uppercase"
          type="submit"
          onClick={submitHandler}
          title="Continuar"
          style={{
            maxWidth: "100%",
            width: "469px",
            marginTop: "30px",
            marginBottom: "30px",
          }}
          // disabled={isSubmitting}
        >
          Continuar
        </button>
      </div>
      {errorMessage && (
        <p style={{ color: "#dc3545", marginBottom: 0 }}>{errorMessage}</p>
      )}
    </div>
  );
};
export default ValidateCode;
